import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

function ForumPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [replyContent, setReplyContent] = useState('');
  
  // 模拟获取帖子数据
  useEffect(() => {
    setLoading(true);
    // 模拟API请求延迟
    setTimeout(() => {
      // 模拟从后端获取的帖子数据
      const postData = {
        id: parseInt(id),
        title: '如何判断主力资金吸筹的关键时期？',
        author: '股市老韭菜',
        avatar: 'https://via.placeholder.com/50',
        date: '2025-03-15 10:30',
        content: `
          <p>在股市操作中，能够准确判断主力资金吸筹阶段的开始和结束，对于投资者的买卖决策至关重要。本帖将分享一些实用的方法，帮助投资者判断主力吸筹的关键时期。</p>
          
          <h3>一、成交量的变化特征</h3>
          <p>主力吸筹阶段通常呈现以下成交量特征：</p>
          <ol>
            <li><strong>温和放量</strong>：相较于前期，成交量会有所放大，但并不剧烈，一般维持在中等水平；</li>
            <li><strong>量价背离</strong>：价格可能下跌或横盘整理，但成交量相对稳定甚至小幅增加；</li>
            <li><strong>尾盘明显增量</strong>：尤其是在收盘前的半小时到一小时，常常出现成交量的显著增加。</li>
          </ol>
          
          <h3>二、K线形态特征</h3>
          <p>在吸筹阶段，K线往往呈现如下特征：</p>
          <ol>
            <li><strong>底部企稳</strong>：股价在一定区域内趋于稳定，不再大幅下跌；</li>
            <li><strong>小阴小阳交替</strong>：出现连续的小阴小阳K线，波动幅度较小；</li>
            <li><strong>长下影线</strong>：经常出现带有长下影线的K线形态，表明低位有人积极接盘；</li>
            <li><strong>阳包阴</strong>：偶尔出现阳包阴的吞没形态，显示短期买盘力量增强。</li>
          </ol>
          
          <h3>三、资金流向分析</h3>
          <p>通过观察资金流向可以更准确地判断主力动向：</p>
          <ol>
            <li><strong>大单净流入增加</strong>：虽然股价不涨，但大单资金净流入明显增加；</li>
            <li><strong>主力席位变化</strong>：主力席位逐渐从卖方转变为买方；</li>
            <li><strong>北向资金（如有）</strong>：如果是大盘蓝筹股，可能会观察到北向资金的持续流入。</li>
          </ol>
          
          <h3>四、筹码分布变化</h3>
          <p>通过筹码分布可以判断吸筹进程：</p>
          <ol>
            <li><strong>筹码集中度提高</strong>：筹码逐渐从松散状态向集中状态转变；</li>
            <li><strong>平均成本下移</strong>：市场平均成本线开始平稳，不再快速下降；</li>
            <li><strong>获利比例变化</strong>：亏损筹码比例增加，但持有者不再恐慌性抛售。</li>
          </ol>
          
          <h3>五、案例分析</h3>
          <p>以某科技股为例，在2024年11月至2025年1月期间，股价从42元回调至32元，之后开始横盘震荡。在这一阶段，我们观察到：</p>
          <ol>
            <li>股价在31-33元区间内小幅波动，K线以小阴小阳为主；</li>
            <li>成交量先萎缩后温和放大，但幅度不大；</li>
            <li>大单资金开始由净流出转为净流入；</li>
            <li>多次出现长下影线K线，显示低位支撑强劲；</li>
            <li>随后在1月下旬，股价突破33元阻力位并快速上涨，确认了主力吸筹完成。</li>
          </ol>
          
          <h3>结论与建议</h3>
          <p>判断主力吸筹需要综合多种因素，不能仅依靠单一指标。当发现上述特征同时出现或大部分出现时，可以判断主力正在进行吸筹活动。此时，投资者可以考虑分批建仓，但仍需注意风险控制，避免重仓操作。</p>
          
          <p>欢迎各位分享自己的经验和看法，共同探讨！</p>
        `,
        views: 532,
        likes: 48,
        replies: [
          {
            id: 1,
            author: '技术派小王',
            avatar: 'https://via.placeholder.com/50',
            date: '2025-03-15 14:22',
            content: '非常感谢分享！关于量价关系的部分特别实用。我想补充一点，MACD指标在底部的金叉也是一个很好的吸筹确认信号，尤其是当它与您提到的K线特征一起出现时。',
            likes: 15
          },
          {
            id: 2,
            author: '价值投资者',
            avatar: 'https://via.placeholder.com/50',
            date: '2025-03-15 16:05',
            content: '从基本面角度看，吸筹期间公司常常会有一些积极的消息释放，比如新产品研发、战略合作等，但市场反应平淡。这也是判断主力吸筹的一个辅助指标。',
            likes: 12
          },
          {
            id: 3,
            author: '抄底高手',
            avatar: 'https://via.placeholder.com/50',
            date: '2025-03-16 09:17',
            content: '老师分享的非常到位！我在实战中还会结合换手率来判断，吸筹初期换手率往往会有所提升，但随着筹码逐渐集中，换手率会逐步下降，这时通常是建仓的好时机。',
            likes: 18
          }
        ],
        tags: ['技术分析', '主力行为', '买点', '实战技巧']
      };
      
      setPost(postData);
      setLoading(false);
    }, 500);
  }, [id]);
  
  const handleSubmitReply = (e) => {
    e.preventDefault();
    
    if (replyContent.trim() === '') {
      alert('回复内容不能为空');
      return;
    }
    
    // 实际应用中这里会调用API提交回复
    alert('回复提交成功！');
    setReplyContent('');
  };
  
  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '50px 0' }}>
        <div>加载中...</div>
      </div>
    );
  }
  
  if (!post) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '50px 0' }}>
        <div>未找到帖子</div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* 面包屑导航 */}
      <div className="breadcrumbs">
        <Link to="/">首页</Link> <span>&gt;</span> 
        <Link to="/forum">交流论坛</Link> <span>&gt;</span> 
        <span>主题详情</span>
      </div>
      
      <div className="section-card">
        <div className="section-header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ fontSize: '18px', margin: 0 }}>{post.title}</h2>
            <div style={{ display: 'flex', gap: '10px' }}>
              <span style={{ fontSize: '14px', color: '#666' }}>
                浏览: {post.views}
              </span>
              <span style={{ fontSize: '14px', color: '#666' }}>
                点赞: {post.likes}
              </span>
            </div>
          </div>
        </div>
        
        <div className="section-content">
          {/* 主帖内容 */}
          <div style={{ 
            padding: '20px',
            borderBottom: '1px solid #e1e4e8'
          }}>
            {/* 作者信息 */}
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img 
                  src={post.avatar} 
                  alt={post.author} 
                  style={{ 
                    width: '50px', 
                    height: '50px', 
                    borderRadius: '50%',
                    marginRight: '10px'
                  }}
                />
                <div>
                  <div style={{ fontWeight: '500' }}>{post.author}</div>
                  <div style={{ fontSize: '14px', color: '#666' }}>{post.date}</div>
                </div>
              </div>
              <div>
                <button style={{ 
                  backgroundColor: '#eef3fd',
                  color: '#1e3a8a',
                  border: 'none',
                  padding: '8px 15px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}>
                  <i className="far fa-thumbs-up" style={{ marginRight: '5px' }}></i>
                  点赞
                </button>
              </div>
            </div>
            
            {/* 帖子内容 */}
            <div 
              className="post-content" 
              style={{ lineHeight: '1.8', fontSize: '16px' }}
              dangerouslySetInnerHTML={{ __html: post.content }}
            />
            
            {/* 帖子标签 */}
            <div style={{ marginTop: '20px' }}>
              {post.tags.map((tag, index) => (
                <span key={index} style={{ 
                  display: 'inline-block',
                  padding: '3px 10px',
                  backgroundColor: '#f5f6fa',
                  color: '#1e3a8a',
                  borderRadius: '4px',
                  fontSize: '14px',
                  marginRight: '8px',
                  marginBottom: '8px'
                }}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
          
          {/* 回复列表 */}
          <div>
            <div style={{ padding: '15px 20px', borderBottom: '1px solid #e1e4e8' }}>
              <h3 style={{ fontSize: '16px', margin: 0 }}>全部回复 ({post.replies.length})</h3>
            </div>
            
            {post.replies.map((reply) => (
              <div key={reply.id} style={{ 
                padding: '20px',
                borderBottom: '1px solid #e1e4e8'
              }}>
                {/* 回复者信息 */}
                <div style={{ 
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '15px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img 
                      src={reply.avatar} 
                      alt={reply.author} 
                      style={{ 
                        width: '40px', 
                        height: '40px', 
                        borderRadius: '50%',
                        marginRight: '10px'
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: '500' }}>{reply.author}</div>
                      <div style={{ fontSize: '14px', color: '#666' }}>{reply.date}</div>
                    </div>
                  </div>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    <i className="far fa-thumbs-up" style={{ marginRight: '5px' }}></i>
                    {reply.likes}
                  </div>
                </div>
                
                {/* 回复内容 */}
                <div style={{ fontSize: '15px', lineHeight: '1.7' }}>
                  {reply.content}
                </div>
                
                {/* 回复操作 */}
                <div style={{ marginTop: '10px', textAlign: 'right' }}>
                  <button style={{ 
                    backgroundColor: 'transparent',
                    color: '#1e3a8a',
                    border: 'none',
                    padding: '5px 10px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}>
                    回复
                  </button>
                  <button style={{ 
                    backgroundColor: 'transparent',
                    color: '#1e3a8a',
                    border: 'none',
                    padding: '5px 10px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}>
                    点赞
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          {/* 回复表单 */}
          <div style={{ padding: '20px' }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px' }}>发表回复</h3>
            <form onSubmit={handleSubmitReply}>
              <textarea 
                value={replyContent}
                onChange={(e) => setReplyContent(e.target.value)}
                style={{ 
                  width: '100%', 
                  minHeight: '150px', 
                  padding: '12px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  marginBottom: '15px',
                  fontFamily: 'inherit',
                  fontSize: '15px'
                }}
                placeholder="请输入回复内容..."
              ></textarea>
              <div style={{ textAlign: 'right' }}>
                <button 
                  type="submit"
                  style={{ 
                    backgroundColor: '#1e3a8a',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  提交回复
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForumPost;
